<template>
  <PageDocument :documentPath="documentPath" :documents-param="documentsParam" />
</template>

<script setup lang="ts">
const route = useRoute();
const documentPath = computed(() => route.path);
const documentsParam = computed(() => route.params.documents);
</script>
